
import { Component, Vue } from 'vue-property-decorator';
import PageContainer from '@/components/PageTemplate/PageContainer.vue';
import PageTableOfContents from '@/components/PageTemplate/PageTableOfContents.vue';

@Component({
  components: {
    PageContainer,
    PageTableOfContents,
  },
})
export default class Drivers extends Vue {
  get driverLinks() {
    return [
      {
        sectionName: this.$t('context.driversPage.sectionTitles.1'),
        sections: [
          {
            name: this.$t('context.driversPage.pages.econPop.pageName'),
            routeName: 'ContextDriversEconPop',
          },
          {
            name: this.$t('context.driversPage.pages.urbanLandUse.pageName'),
            routeName: 'ContextDriversUrbanLandUse',
          },
          {
            name: this.$t('context.driversPage.pages.climateStatus.pageName'),
            routeName: 'ContextDriversClimateStatus',
          },
          {
            name: this.$t('context.driversPage.pages.energyWaterNeed.pageName'),
            routeName: 'ContextDriversEnergyWaterNeeds',
          },
          {
            name: this.$t('context.driversPage.pages.agConditions.pageName'),
            routeName: 'ContextDriversAgriculturalConditions',
          },
          {
            name: this.$t('context.driversPage.pages.muniIndustCond.pageName'),
            routeName: 'ContextMuniIndustrialConditions',
          },
          {
            name: this.$t('context.driversPage.pages.waterEffTech.pageName'),
            routeName: 'ContextDriversWaterEfficiencyTech',
          },
          {
            name: this.$t('context.driversPage.pages.socValues.pageName'),
            routeName: 'ContextDriversSocialVals',
          },
          {
            name: this.$t('context.driversPage.pages.regConstraint.pageName'),
            routeName: 'ContextDriversRegConstraints',
          },
        ],
      },
      // {
      //   sectionName: this.$t('context.driversPage.sectionTitles.2'),
      //   sections: [
      //     {
      //       name: this.$t('context.driversPage.pages.interactiveTool.pageName'),
      //       routeName: 'ContextDriversInteractiveTool',
      //     },
      //   ],
      // },
    ];
  }
}
